module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "review-order-condition-setting"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("传单前必须满足审单条件后才能传单")]), _vm._v(" "), _c('div', {
    staticClass: "setting-item"
  }, [_c('div', [_c('span', [_vm._v("可按需配置审单条件，当订单满足指定审单条件时自动生成审单任务，支持设置是否审核通过才能传单。说明：传单权限与MTDS传单权限保持一致。")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "是",
      "inactive-text": "否",
      "active-value": 0,
      "inactive-value": 1
    },
    on: {
      "change": _vm.changeReviewOrderConditionStatus
    },
    model: {
      value: (_vm.reviewOrderCondition.status),
      callback: function($$v) {
        _vm.$set(_vm.reviewOrderCondition, "status", $$v)
      },
      expression: "reviewOrderCondition.status"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_vm._v("\n          导出\n        ")]), _vm._v(" "), _c('el-upload', {
    ref: "uploadRef",
    staticStyle: {
      "margin-left": "10px",
      "display": "inline-block"
    },
    attrs: {
      "auto-upload": false,
      "show-file-list": false,
      "on-change": _vm.handleFileChange,
      "accept": ".xlsx,.xls",
      "action": "#"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(" 导入 ")])], 1)], 1), _vm._v(" "), (!_vm.reviewOrderCondition.status) ? _c('div', {
    staticClass: "review-order-condition-table"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.reviewOrderCondition.conditionList,
      "border": "",
      "size": "mini"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "min-width": "125"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('span', [_vm._v("条件")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "text"
          },
          on: {
            "click": _vm.addReviewOrderCondition
          }
        }, [_vm._v("添加条件")])]
      },
      proxy: true
    }, {
      key: "default",
      fn: function(ref) {
        var $index = ref.$index;
        var row = ref.row;

        return [_c('span', [_vm._v("条件" + _vm._s($index + 1))]), _vm._v(" "), _c('div', [_c('el-checkbox', {
          attrs: {
            "true-label": 1,
            "false-label": 0
          },
          model: {
            value: (row.isAuditRequiredForTransmit),
            callback: function($$v) {
              _vm.$set(row, "isAuditRequiredForTransmit", $$v)
            },
            expression: "row.isAuditRequiredForTransmit"
          }
        }, [_vm._v("\n                  审核通过才能传单\n                ")])], 1)]
      }
    }], null, false, 886213265)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('span', [_vm._v("审单界面条件说明文本")]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "配置需要在审单任务中展示的审单说明，如“新设计师订单需要审核”、“遗留单需要审核”等",
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "el-icon-warning",
          staticStyle: {
            "cursor": "pointer"
          }
        })])]
      },
      proxy: true
    }, {
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-input', {
          attrs: {
            "type": "textarea",
            "autosize": {
              minRows: 6,
              maxRows: 10
            },
            "size": "small"
          },
          model: {
            value: (row.explanationText),
            callback: function($$v) {
              _vm.$set(row, "explanationText", $$v)
            },
            expression: "row.explanationText"
          }
        })]
      }
    }], null, false, 2057577746)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "min-width": "400"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('span', [_vm._v("审单要求(需符合该条件的所有要求)")]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "同一级审核人若配置多个则任意一个审核即可，所有环节审核人审核顺序不分先后\n",
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "el-icon-warning",
          staticStyle: {
            "cursor": "pointer"
          }
        })])]
      },
      proxy: true
    }, {
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticClass: "review-order-requirement"
        }, [_c('div', [_c('span', [_vm._v("组织架构/指定人员要求：")]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": ("部门：" + (_vm.getListLabelByKey(row, 'departmentList')))
          }
        }, [_c('div', {
          staticClass: "reviewer-label-ellipsis reviewer-value-clickable",
          on: {
            "click": function($event) {
              return _vm.handleSetting(row, 'setting')
            }
          }
        }, [_vm._v("\n                      部门：" + _vm._s(_vm.getListLabelByKey(row, "departmentList")) + "\n                    ")])]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": ("人员：" + (_vm.getListLabelByKey(row, 'personList')))
          }
        }, [_c('div', {
          staticClass: "reviewer-label-ellipsis reviewer-value-clickable",
          on: {
            "click": function($event) {
              return _vm.handleSetting(row, 'setting')
            }
          }
        }, [_vm._v("\n                      人员：" + _vm._s(_vm.getListLabelByKey(row, "personList")) + "\n                    ")])]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleSetting(row, 'setting')
            }
          }
        }, [_vm._v("设置")])], 1), _vm._v(" "), _c('div', [_c('span', [_vm._v("人员入职时间要求：")]), _vm._v(" "), _c('el-select', {
          attrs: {
            "size": "mini",
            "placeholder": "请选择",
            "clearable": ""
          },
          model: {
            value: (row.personEntryTime),
            callback: function($$v) {
              _vm.$set(row, "personEntryTime", $$v)
            },
            expression: "row.personEntryTime"
          }
        }, _vm._l((_vm.personEntryTimeOptions), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1), _vm._v(" "), _c('span', {
          style: ({
            opacity: 0
          })
        }, [_vm._v("占位")])], 1), _vm._v(" "), _c('div', [_c('span', [_vm._v("订单属性要求：")]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": _vm.getOrderConditionStatus(row)
          }
        }, [_c('span', {
          staticClass: "reviewer-label-ellipsis reviewer-value-clickable",
          on: {
            "click": function($event) {
              return _vm.handleSetting(row, 'orderCondition')
            }
          }
        }, [_vm._v("\n                      " + _vm._s(_vm.getOrderConditionStatus(row)) + "\n                    ")])]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleSetting(row, 'orderCondition')
            }
          }
        }, [_vm._v("设置")])], 1), _vm._v(" "), _c('div', [_c('span', [_vm._v("设计指标要求：")]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": "业务需求收集中，欢迎反馈！"
          }
        }, [_c('span', {
          staticClass: "reviewer-label-ellipsis reviewer-value-disabled"
        }, [_vm._v("\n                      业务需求收集中，欢迎反馈！\n                    ")])]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "text",
            "disabled": true
          }
        }, [_vm._v("设置")])], 1), _vm._v(" "), _c('div', [_c('span', [_vm._v("财务指标要求：")]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": "业务需求收集中，欢迎反馈！"
          }
        }, [_c('span', {
          staticClass: "reviewer-label-ellipsis reviewer-value-disabled"
        }, [_vm._v("\n                      业务需求收集中，欢迎反馈！\n                    ")])]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "text",
            "disabled": true
          }
        }, [_vm._v("设置")])], 1), _vm._v(" "), _c('div', [_c('span', [_vm._v(" 第一环节审核人： ")]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": _vm.getListLabelByKey(row, 'firstStageReviewerList')
          }
        }, [_c('span', {
          staticClass: "reviewer-label-ellipsis reviewer-value-clickable",
          on: {
            "click": function($event) {
              return _vm.handleSetting(row, 'firstStageReviewerList')
            }
          }
        }, [_vm._v("\n                      " + _vm._s(_vm.getListLabelByKey(row, "firstStageReviewerList")) + "\n                    ")])]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleSetting(row, 'firstStageReviewerList')
            }
          }
        }, [_vm._v("设置")])], 1), _vm._v(" "), _c('div', [_c('span', [_vm._v(" 第二环节审核人： ")]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": _vm.getListLabelByKey(row, 'secondStageReviewerList')
          }
        }, [_c('span', {
          staticClass: "reviewer-label-ellipsis reviewer-value-clickable",
          on: {
            "click": function($event) {
              return _vm.handleSetting(row, 'secondStageReviewerList')
            }
          }
        }, [_vm._v("\n                      " + _vm._s(_vm.getListLabelByKey(row, "secondStageReviewerList")) + "\n                    ")])]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleSetting(row, 'secondStageReviewerList')
            }
          }
        }, [_vm._v("设置")])], 1), _vm._v(" "), _c('div', [_c('span', [_vm._v(" 第三环节审核人： ")]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "placement": "top",
            "content": _vm.getListLabelByKey(row, 'thirdStageReviewerList')
          }
        }, [_c('span', {
          staticClass: "reviewer-label-ellipsis reviewer-value-clickable",
          on: {
            "click": function($event) {
              return _vm.handleSetting(row, 'thirdStageReviewerList')
            }
          }
        }, [_vm._v("\n                      " + _vm._s(_vm.getListLabelByKey(row, "thirdStageReviewerList")) + "\n                    ")])]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleSetting(row, 'thirdStageReviewerList')
            }
          }
        }, [_vm._v("设置")])], 1)])]
      }
    }], null, false, 1142385167)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "min-width": "125",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.copyReviewOrderCondition(row)
            }
          }
        }, [_vm._v("\n                复制\n              ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.deleteReviewOrderCondition(row)
            }
          }
        }, [_vm._v("\n                删除\n              ")])]
      }
    }], null, false, 2909072149)
  })], 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.orderConditionListDialogVisible) ? _c('OrderConditionDialog', {
    attrs: {
      "visible": _vm.orderConditionListDialogVisible,
      "value": _vm.currentOrderConditionRow.orderConditionList
    },
    on: {
      "update:visible": function($event) {
        _vm.orderConditionListDialogVisible = $event
      },
      "confirm": _vm.handleOrderConditionConfirm
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fcbe704"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/developerInfo/components/reviewOrderCondition.vue
// module id = 2412
// module chunks = 68